import {Locales} from '@netx/core-next/locales';

/**
 * Common schema validation error labels
 */
export const SchemaValidationErrorLabel = Locales((i18n) => ({
	DATE_INVALID: i18n('i18n.invalidDate'),
	DATE_MUST_BE_IN_THE_FUTURE: i18n('i18n.validationDateMustBeInTheFuture'),
	REQUIRED: i18n('i18n.required'),
}));
